import * as React from 'react';
import { ComponentPropsWithoutRef } from 'react';
import { ArrowUpSmallCircleFillIcon } from '@zep/icons';
import { cn } from '@zep/utils';
type SendButtonProps = ComponentPropsWithoutRef<typeof ArrowUpSmallCircleFillIcon> & {
  disabled?: boolean;
};
export const SendButton = ({
  className,
  disabled,
  ...rest
}: SendButtonProps) => {
  return <ArrowUpSmallCircleFillIcon className={cn('text-primary cursor-pointer', disabled && 'text-gray-400 touch-none cursor-not-allowed', className)} {...rest} data-sentry-element="ArrowUpSmallCircleFillIcon" data-sentry-component="SendButton" data-sentry-source-file="SendButton.tsx" />;
};